module.exports = __webpack_public_path__ + "img/Maldives.510b765a.svg";